import { IFileInFolderInfo } from 'isogd-file-rest';

class FileInFnEdController {
    file: IFileInFolderInfo;
    extension: string;
    name: string;
    size: string;
    date: Date;
    onDelete: (args: any) => void;
    $onInit() {
        this.extension = this.file.fileName.split('.').pop().toLowerCase();
        this.name = this.file.fileName;
        let sizeKB = this.file.fileSize / 1024.0;
        let isKB = (sizeKB < 1024.0) ? true : false;
        this.size = (isKB) ? sizeKB.toFixed(1).toString() + ' Кб' : (sizeKB / 1024.0).toFixed(2).toString() + ' Мб';
        this.date = new Date(this.file.dateLastModified);
    }

    open(id: string) {
        let url = `isogd-api/v2/files/view/${id}`;
        window.open(url, '_blank');
    }

    delete(file: File) {
        this.onDelete({file: file});
    }
}

export const fileInFnEd: angular.IComponentOptions = {
    controller: FileInFnEdController,
    template: require('./fileInFnEd.html'),
    bindings: {
        file: '<',
        onDelete: '&'
    }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/file/fileInFnEd.ts